import React, { useState } from 'react';
import Form from '../../components/common/Form';
import FormSection from '../../components/common/FormSection';
import FormField from '../../components/common/FormField';
import { FellowDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';
import { useFormValidation, ValidationRules } from '../../hooks/useFormValidation';
import { useProvinces } from '../../hooks/useProvinceApi';

interface FellowFormProps {
  initialValues: FellowDTO;
  onSubmit: (data: FellowDTO) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const FORM_SECTIONS = {
  basicInfo: {
    id: 'basic-info',
    title: 'Basic Information'
  }
} as const;

const FellowForm: React.FC<FellowFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
  isLoading = false
}) => {
  const [formData, setFormData] = useState<FellowDTO>(initialValues);

  const { data: provinces, isLoading: isLoadingProvinces } = useProvinces();

  const validationRules: ValidationRules = {

  };

  const { errors, validate } = useFormValidation<FellowDTO>(validationRules);

  const handleSave = () => {
    if (validate(formData)) {
      onSubmit(formData);
    }
  };

  const sections = Object.values(FORM_SECTIONS);

  return (
    <Form sections={sections} onSave={handleSave} onCancel={onCancel} isSubmitting={isLoading}>
      <FormSection
        id={FORM_SECTIONS.basicInfo.id}
        title={FORM_SECTIONS.basicInfo.title}
      >
        <FormField
          id="name"
          label="Name"
          type="text"
          value={formData.name || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Name"
          required={false}
          error={errors.name}
        />
        <FormField
          id="companyName"
          label="Company Name"
          type="text"
          value={formData.companyName || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Company Name"
          required={false}
          error={errors.companyName}
        />
        <FormField
          id="email"
          label="Email"
          type="text"
          value={formData.email || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Email"
          required={false}
          error={errors.email}
        />
        <FormField
          id="phoneNumber"
          label="Phone Number"
          type="text"
          value={formData.phoneNumber || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Phone Number"
          required={false}
          error={errors.phoneNumber}
        />
        <FormField
          id="provinceId"
          label="Province"
          type="dropdown"
          value={formData.provinceId || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Select a Province"
          required={false}
          error={errors.provinceId}
          options={(provinces || []).map((type) => ({
            value: type.id,
            label: type.title || '',
          }))}
          isLoading={isLoadingProvinces}
        />
        <FormField
          id="website"
          label="Website"
          type="text"
          value={formData.website || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Website"
          required={false}
          error={errors.website}
        />
        <FormField
          id="canWriteEndorsementMotivations"
          label="Can Write Endorsement Motivations"
          type="checkbox"
          value={formData.canWriteEndorsementMotivations || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Can Write Endorsement Motivations"
          required={false}
          error={errors.canWriteEndorsementMotivations}
        />
        <FormField
          id="isActive"
          label="Active"
          type="checkbox"
          value={formData.isActive || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Is Active"
          required={false}
          error={errors.isActive}
        />

      </FormSection>
    </Form>
  );
};

export default FellowForm;